import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface DropDownListProps extends KendoWidgetProps, kendo.ui.DropDownListOptions {
    children?: React.ReactNode;
}

export default class DropDownList extends KendoBaseComponent<DropDownListProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.DropDownList(domNode as Element, props);
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, dataSource, ...props } = this.props;
            this.widgetInstance.setOptions(props);
            const widget = (this.widgetInstance as kendo.ui.DropDownList);

            if (widget.options.dataSource !== dataSource) {
                widget.setDataSource(dataSource);
            }
            (this.widgetInstance as kendo.ui.DropDownList).value(this.props.value as string);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'input'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <input ref={this.elementRef} />;
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-react-wrapper/src/dropdownlist/index.tsx